import {
  AddCircleOutlineOutlined,
  Delete,
  RemoveCircleOutlineOutlined,
} from "@mui/icons-material";
import {
  ButtonGroup,
  IconButton,
  ListItem,
  ListItemText,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import { SxProps } from "@mui/system";
import { t } from "i18next";
import { ReactNode } from "react";
import { Violation } from "types";

interface ViolationListItemProps {
  item: Violation;
  active: boolean;
  sx: SxProps;
  onMoveClick: (item: Violation) => void;
  onDeleteClick?: (item: Violation) => void;
  disabled?: boolean;
  canUpdateViolations?: boolean;
}

const ViolationListItem = ({
  item,
  active,
  sx,
  onMoveClick,
  onDeleteClick,
  disabled = false,
  canUpdateViolations = false,
}: ViolationListItemProps): ReactNode => {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.only("sm"));

  return (
    <ListItem
      style={{ pointerEvents: canUpdateViolations ? "all" : "none" }}
      dense={!isTablet}
      sx={sx}
      divider={true}
      secondaryAction={
        canUpdateViolations ? (
          <ButtonGroup disabled={disabled} sx={{ px: 1 }}>
            {!active && typeof item.tenantID !== "undefined" && (
              <IconButton
                onClick={() => onDeleteClick && onDeleteClick(item)}
                size={"medium"}
              >
                <Delete color={"error"} fontSize={"medium"} />
              </IconButton>
            )}
            {active && canUpdateViolations && (
              <IconButton onClick={() => onMoveClick(item)} size={"medium"}>
                <RemoveCircleOutlineOutlined
                  color={"error"}
                  fontSize={"medium"}
                />
              </IconButton>
            )}
            {!active && canUpdateViolations && (
              <IconButton onClick={() => onMoveClick(item)}>
                <AddCircleOutlineOutlined
                  color={"success"}
                  fontSize={"medium"}
                />
              </IconButton>
            )}
          </ButtonGroup>
        ) : null
      }
    >
      <ListItemText
        sx={{ p: 0.5 }}
        primary={item.name}
        secondary={item.description !== item.name ? item.description : ""}
        primaryTypographyProps={{
          noWrap: true,
          variant: isTablet ? "h6" : "body2",
          fontWeight: "bold",
        }}
        secondaryTypographyProps={{ noWrap: true, variant: "subtitle2" }}
      />
    </ListItem>
  );
};

export default ViolationListItem;
